import { Configuration } from "node-library/dist/portal";

const Config: Configuration = {
	host: process.env.REACT_APP_API_HOST,
	port: process.env.REACT_APP_API_PORT,
	frontendBaseUrl: process.env.REACT_APP_API_HOST,
	reCaptchaKey: process.env.REACT_APP_API_RECAPTCHA_KEY,
};

export default Config;
